/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BlockTimeCheckbox/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BlockTimeCheckbox({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/BlockTimeCheckbox"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let scheduleNoteTypeValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'type',
})
let globalCurrentLocationPermissionsHasCalendarBlockScheduleValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.permissions.has_calendar_block_schedule',
})
let aggregateData = fromHelpers.getView(scheduleNoteTypeValueData, globalCurrentLocationPermissionsHasCalendarBlockScheduleValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}